<template>
	<div ref="scrollArea" class="assets-list">
		<div
			v-for="media in assets"
			:key="media.key"
			class="assets-item"
		>
			<div class="assets-item__figure">
				<img
					v-if="media.mime_type.includes('image')"
					:src="`${mediaURL}${media.key}`"
					:alt="media.filename"
					loading="lazy"
				>
				<div
					class="assets-item__layer"
					@click.stop="isChoosing ? $emit('chosen', media) : null"
				>
					<div v-if="!isChoosing" class="button-wrapper button-wrapper--assets">
						<div
							class="button button--assets bg--dusky-rose"
							@click="$emit('chosen', media)"
						><i class="fas fa-link"></i></div>
					</div>
				</div>
			</div>
			<div class="assets-item__title">
				<span>{{ media.filename }}</span>
				<div class="assets-item__tooltip">{{ media.filename }}</div>
			</div>
		</div>
	</div>
	<list-more
		:has-more="hasMore"
		:loading="loadingMore"
		:total="total"
		@load="loadMore"
	></list-more>
</template>

<script setup>
import {onBeforeUnmount, onMounted, ref, watch} from 'vue';
import ListMore from '@/components/overview/ListMore.vue';
import useInfiniteList from '@/utils/useInfiniteList';

const props = defineProps({
	// The category's ID, which is what the server filters on — the panel's
	// own title is one of its names.
	categoryId: {
		type: Number,
		required: true
	},
	assetsURL: {
		type: String,
		required: true
	},
	mediaURL: {
		type: String,
		default: ''
	},
	mapId: {
		type: [Number, String],
		default: null
	},
	isChoosing: {
		type: Boolean,
		default: false
	},
	// The panel is collapsed until it is opened; there is no point paging a
	// list nobody can see, and no way to scroll one either.
	active: {
		type: Boolean,
		default: false
	}
});

defineEmits(['chosen']);

const scrollArea = ref(null);
const {
	items: assets,
	total,
	hasMore,
	loadingMore,
	load: loadAssets,
	loadMore,
	trackScroll,
	dispose
} = useInfiniteList({
	url: () => props.assetsURL,
	params: () => ({
		map: props.mapId,
		templates: 'only',
		category: props.categoryId,
		type: props.isChoosing ? 'image' : undefined
	})
});

let loaded = false;

function loadOnce() {
	if (loaded || !props.active) return;
	loaded = true;
	loadAssets();
}

onMounted(() => {
	trackScroll(scrollArea.value);
	loadOnce();
});
watch(scrollArea, element => trackScroll(element));
watch(() => props.active, loadOnce);
onBeforeUnmount(dispose);
</script>
